import { StreamType } from '../../enums';
import { useGetTracks } from '../../hooks';
import { useSetLiveView } from '../../hooks/useSetLiveView';
import { RtmpTrackViewLayout } from './RtmpTrackViewLayout';

export const RtmpView = () => {
  const { tracks } = useGetTracks();
  const videoTrack = tracks[StreamType.Rtmp];

  useSetLiveView({
    component: 'rtmpView',
    disableSetLive: true,
    streamType: StreamType.Rtmp,
    videoTracks: [],
  });

  return <RtmpTrackViewLayout videoTrack={videoTrack} />;
};
